//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from "vuex";
import AQTooltip from "@/components/Generics/AQTooltip/AQTooltip.vue";
import AQModal from "@/components/Generics/AQModal/AQModal.vue";
import AQCard from "@/components/Generics/AQCard/AQCard.vue";
import AQDropdown from "@/components/Generics/AQDropdown/AQDropdown.vue";
import AQInput from "@/components/Generics/AQInput/AQInput.vue";
import PluginReadonlyContainer from "../../sidebar/plugin-readonly-container.vue";
import { PLUGIN_CUSTOM_PROPS } from "../../sidebar/const/plugin-custom-props";

export default {
    name: "SetApiErrors",
    components: {
        PluginReadonlyContainer,
        AQTooltip,
        AQModal,
        AQDropdown,
        AQInput,
        AQCard
    },
    props: {
        errorsObject: Array,
        arrayPath: Array
    },
    data() {
        return {
            sizeCanvas: PLUGIN_CUSTOM_PROPS,
            modalError: false,
            errNumber: "",
            errDescription: "",
            errPath: "",
            readonly: true,
            index: "",
            noPathSelected: false,
            arrayOption: [],
            disabledAdd: false,
            add: {
                label: this.$t("generic.add"),
                disabled: false
            },
            selectPathMod: []
        };
    },
    computed: {
        ...mapGetters("diagrams", ["diagramData"]),
        getSelectPathProps() {
            return {
                label: this.$t("diagrams.components.configApi.actionErr"),
                options: this.arrayPath,
                errorLabel: this.$t("diagrams.components.configApi.warningDefultPath"),
                error: this.noPathSelected,
                disable: !this.arrayPath.length
            };
        }
    },
    methods: {
        setTitle(value) {
            let title = "";
            if (value) {
                title = value.value && value.value[0]
                    ? (`${this.$t("diagrams.components.configApi.error")} ${value.value[0]}`)
                    : (`${this.$t("diagrams.components.configApi.error")} ${value[0]}`);
            }
            return title;
        },
        setTooltip(value) {
            let tooltip = "";
            if (value) {
                tooltip += value.value && value.value[1] ? value.value[1].description : value[1].description;
            }
            return tooltip;
        },
        valueSelected(option) {
            this.noPathSelected = false;
            this.errPath = option.length ? option[0].value : "";
            this.add.disabled = !option.length;
        },
        openModalError(obj, index) {
            this.arrayOption = [];
            this.modalError = true;
            this.index = index;
            this.add.disabled = true;
            const pathLoaded = obj && obj.action ? obj.action : "";
            this.selectPathMod = this.arrayPath.filter(elem => elem.value === pathLoaded);
            this.rulePath = this.selectPathMod.length ? this.selectPathMod[0].value : "";
            this.errNumber = obj && obj.value ? obj.value[0] : obj[0];
            this.errDescription = obj && obj.value ? obj.value[1].description : obj[1].description;
            this.noPathSelected = false;
        },
        action($event) {
            if ($event === "primary") {
                if (this.errPath) {
                    let toElem; let idCanvas; let labelCanvas;
                    this.diagramData.connectors.find(conector => {
                        if (conector.uuid === this.errPath) {
                            toElem = conector.to;
                            this.diagramData.content.find(elem => {
                                if (elem.uuid === toElem) {
                                    idCanvas = elem.id;
                                    labelCanvas = elem.label.value;
                                    return true;
                                }
                                return false;
                            });
                            return true;
                        }
                        return false;
                    });
                    const newObject = {
                        action: this.errPath,
                        idPlugin: idCanvas,
                        labelPlugin: labelCanvas,
                        value: [this.errNumber, this.errDescription]
                    };
                    // eslint-disable-next-line
                    this.errorsObject[this.index] = newObject;
                    this.$emit("updateErrors", this.errorsObject);
                    this.noPathSelected = false;
                    this.modalError = false;
                } else {
                    this.noPathSelected = true;
                }
            } else {
                this.modalError = false;
            }
        }
    }
};

